// NOTE: This is a noop on purpose. Add future region redirects here if needed
// We only need a region redirect for PLK if the users are based in India.

const useRegionRedirect = () => {};

export default useRegionRedirect;
